module.exports = __webpack_public_path__ + "img/gsb45.78753915.png";